(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["dynamic-blog-posts"] && !window.DesignMode) return;
  try {
    
  const ArticleItem = function (article, index) {
    return `<article class="promo-block rise-recent-article index-`+ index +`" style="background-image:url('` + article.thumbnail_url + `')">`
      + '<a href="' + article.url + '" title="' + article.title + '" class="promo-block--content" target="_blank">'            
      + '<div class="rise-recent-article-content-wrapper"><h2 class="rise-recent-article-title">' + article.title + '</h2>'
      + '<p class"promo-block--text">' + article.summary + '</p></div>'
      + '</a></article>'
  }
  
  function renderLatestArticles (data) {
    // Recent Articles
    data.forEach(function(article, index) {
      var articleItem = ArticleItem(article, index)
      $('.recent-articles').append(articleItem)
    })
  }

  
  function getLatestArticles() {
    const settings = {
      async: true,
      crossDomain: true,
      url: 'https://www.buildwithrise.com/recent-articles',
      method: 'GET'      
    };

    return $.ajax(settings);
  }
  
  $(function() {
    // Get recent content via CORS request
    getLatestArticles().done(function (data) {
		renderLatestArticles(data);
    })
    .fail(function (data) {
      $('.recent-articles').hide();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rise-related-info"]) return;
  try {
    
const ProductItem = function (product, total) {
  let indexStr = total >= 5 ? 'index-0' : '';
  return (
    `<article class="promo-block rise-related-article ${indexStr}" style="background-image:url('${product.image}')">` +
    '<a href="' + product.url + '" title="' + product.title + '" class="promo-block--content" target="_blank">' +
    '<div class="rise-related-article-content-wrapper"><h2 class="rise-related-article-title">' + product.title + '</h2>' +
    '<p class="promo-block--text">' + product.description + '</p></div>' +
    '</a></article>'
  );
};

const ArticleItem = function (article, index, total, noProduct) {
  let indexValue = noProduct ? index : index + 1;
  let indexStr = total >= 5 ? `index-${indexValue}` : '';
  return (
    `<article class="promo-block rise-related-article ${indexStr}" style="background-image:url('${article.thumbnail_url}')">` +
    '<a href="' + article.url + '" title="' + article.title + '" class="promo-block--content" target="_blank">' +
    '<div class="rise-related-article-content-wrapper"><h2 class="rise-related-article-title">' + article.title + '</h2>' +
    '<p class="promo-block--text">' + article.summary + '</p></div>' +
    '</a></article>'
  );
};

function renderRelatedProducts(data, total) {
  // Related Products
  data.forEach(function (product) {
    var productItem = ProductItem(product, total);
    $(".related-content").append(productItem);
  });
}

function renderRelatedArticles(data, total, noProduct) {
  // Related Articles
  data.forEach(function (article, index) {
    var articleItem = ArticleItem(article, index, total, noProduct);
    $(".related-content").append(articleItem);
  });
}

function getRelatedContent(tags) {
  const settings = {
    async: true,
    crossDomain: true,
    url: "https://d3990iwfnglr0g.cloudfront.net/related-by-tag",
    method: "GET",
    data: {
      tags: tags
    }
  };

  return $.ajax(settings);
}

$(function () {
  let productTag = $('script[data-section-type="rise-related-info"]').data(
    "section-id"
  );

  var tags = productTag;

  if (!productTag || productTag.length === 0) {
    return;
  }

  // Get related content via CORS request
  getRelatedContent(tags)
    .done(function (data) {
      let totalItems = data.products.length + data.articles.length;
      if (totalItems < 4) {
        $(".related-content").css("grid-template-columns", "repeat(3, 1fr)");
      }
      if (totalItems === 4) {
        $(".related-content").css("grid-template-columns", "repeat(2, 1fr)");
        $(".related-content").css("grid-template-rows", "repeat(2, 1fr)");
      }
      // RELATED PRODUCTS
      if (data.products && data.products.length > 0) {
        renderRelatedProducts(data.products, totalItems);
      }

      // RELATED ARTICLES
      if (data.articles && data.articles.length > 0) {
        let articles = data.articles;
        let noProduct = data.products.length === 0;
        if (data.products && data.products.length > 0) {
          articles = data.articles.slice(0, 4);
        }
        renderRelatedArticles(articles, totalItems, noProduct);
      }

      // Hide related content if there are zero results
      if (
        data.articles &&
        data.articles.length === 0 &&
        data.products &&
        data.products.length === 0
      ) {
        $(".related-container").hide();
      } else {
        $(".related-container").show();
      }
    })
    .fail(function (data) {
      // Hide related content if there is an error in getting data
      $(".related-container").hide();
    });
});

  } catch(e) { console.error(e); }
})();

})();
